import { Facebook, Instagram, Linkedin, ChevronDown } from "lucide-react";
import { Disclosure } from "@headlessui/react";
import { Link } from "react-router-dom";

export default function Footer() {
  const mobileSections = [
    {
      title: "Keşfet",
      links: [
        { label: "Nasıl Çalışır", type: "anchor", href: "#how" },
        { label: "Kimler İçin", type: "anchor", href: "#who" },
        { label: "Uygulamayı İndir", type: "route", to: "/indir" },
      ],
    },
    {
      title: "Destek",
      links: [
        { label: "Destek Merkezi", type: "route", to: "/destek" },
        { label: "Sık Sorulan Sorular", type: "anchor", href: "#faq" },
        { label: "Gizlilik Politikası", type: "route", to: "/gizlilik" },
        { label: "KVKK Aydınlatma Metni", type: "route", to: "/kvkk" },
        { label: "Kullanım Koşulları", type: "route", to: "/kullanim-kosullari" },
      ],
    },
  ];

  return (
    <footer className="relative mt-32 overflow-hidden bg-gradient-to-b from-black via-neutral-900 to-black px-6 pb-12 pt-20 text-white md:px-12">
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:40px_40px] opacity-10"></div>

      <div className="relative z-10 mx-auto max-w-7xl rounded-3xl border border-neutral-800 bg-neutral-900/70 p-12 backdrop-blur-xl md:p-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-4">
          <div>
            <h2 className="mb-4 text-4xl font-extrabold">KolayYük</h2>
            <p className="max-w-sm text-sm leading-relaxed text-gray-400">
              Türkiye’nin dijital yük taşıma ağı. Lojistikte teklif alma ve yük
              bulmayı çok daha hızlı ve kolay hale getiriyoruz.
            </p>

            <a
              href="mailto:info@kolayyuk.com"
              className="mt-4 inline-block text-sm text-gray-400 transition hover:text-white hover:underline underline-offset-4"
            >
              info@kolayyuk.com
            </a>
          </div>

          <div className="hidden md:block">
            <h3 className="mb-4 text-lg font-semibold">Keşfet</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <a
                  href="#how"
                  className="transition hover:text-white hover:underline underline-offset-4"
                >
                  Nasıl Çalışır
                </a>
              </li>
              <li>
                <a
                  href="#who"
                  className="transition hover:text-white hover:underline underline-offset-4"
                >
                  Kimler İçin
                </a>
              </li>
              <li>
                <Link
                  to="/indir"
                  className="transition hover:text-white hover:underline underline-offset-4"
                >
                  Uygulamayı İndir
                </Link>
              </li>
            </ul>
          </div>

          <div className="hidden md:block">
            <h3 className="mb-4 text-lg font-semibold">Destek</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <Link
                  to="/destek"
                  className="transition hover:text-white hover:underline underline-offset-4"
                >
                  Destek Merkezi
                </Link>
              </li>

              <li>
                <a
                  href="#faq"
                  className="transition hover:text-white hover:underline underline-offset-4"
                >
                  Sık Sorulan Sorular
                </a>
              </li>

              <li>
                <Link
                  to="/gizlilik"
                  className="transition hover:text-white hover:underline underline-offset-4"
                >
                  Gizlilik Politikası
                </Link>
              </li>

              <li>
                <Link
                  to="/kvkk"
                  className="transition hover:text-white hover:underline underline-offset-4"
                >
                  KVKK Aydınlatma Metni
                </Link>
              </li>

              <li>
                <Link
                  to="/kullanim-kosullari"
                  className="transition hover:text-white hover:underline underline-offset-4"
                >
                  Kullanım Koşulları
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-semibold">Bizi Takip Et</h3>

            <div className="flex gap-4">
              {[
                { Icon: Linkedin, link: "https://linkedin.com" },
                { Icon: Instagram, link: "https://www.instagram.com/kolayyuk/" },
                { Icon: Facebook, link: "https://facebook.com" },
              ].map(({ Icon, link }, i) => (
                <a
                  key={i}
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full border border-neutral-700 p-3 text-gray-400 transition hover:scale-110 hover:bg-white/10 hover:text-white active:scale-95"
                >
                  <Icon size={20} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 space-y-6 md:hidden">
          {mobileSections.map((sec, i) => (
            <Disclosure key={i}>
              {({ open }) => (
                <div className="rounded-xl border border-neutral-800">
                  <Disclosure.Button className="flex w-full items-center justify-between px-5 py-4 text-left font-medium text-white">
                    {sec.title}
                    <ChevronDown
                      className={`h-5 w-5 transition-transform ${
                        open ? "rotate-180" : ""
                      }`}
                    />
                  </Disclosure.Button>

                  <Disclosure.Panel className="space-y-3 px-5 pb-4 text-sm text-gray-400">
                    {sec.links.map((l, idx) => {
                      if (l.type === "route") {
                        return (
                          <Link
                            key={idx}
                            to={l.to}
                            className="block transition hover:text-white"
                          >
                            {l.label}
                          </Link>
                        );
                      }

                      return (
                        <a
                          key={idx}
                          href={l.href}
                          className="block transition hover:text-white"
                        >
                          {l.label}
                        </a>
                      );
                    })}
                  </Disclosure.Panel>
                </div>
              )}
            </Disclosure>
          ))}
        </div>
      </div>

      <div className="mt-10 text-center text-xs text-gray-500">
        <p>© 2025 KolayYük — Tüm Hakları Saklıdır.</p>
        <p className="mt-1">
          Developed by <span className="font-medium text-white">Kaan</span>
        </p>

        <div className="mt-3 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/destek"
            className="transition hover:text-white hover:underline underline-offset-4"
          >
            Destek
          </Link>

          <Link
            to="/gizlilik"
            className="transition hover:text-white hover:underline underline-offset-4"
          >
            Gizlilik
          </Link>

          <Link
            to="/kvkk"
            className="transition hover:text-white hover:underline underline-offset-4"
          >
            KVKK
          </Link>

          <Link
            to="/kullanim-kosullari"
            className="transition hover:text-white hover:underline underline-offset-4"
          >
            Kullanım Koşulları
          </Link>
        </div>
      </div>
    </footer>
  );
}